import React, {useEffect} from "react";
import {observer} from "mobx-react";
import { Modal} from 'antd';
import {paymentPosStore} from "../PaymentPosStore";
import {OrbitProgress} from "react-loading-indicators";
import {useNavigate} from "react-router-dom";

const ModalSmartPosLoading = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (paymentPosStore.timeLeft <= 0) {
            paymentPosStore.fetchCancelPaymentPos((route) => navigate(route)); // Gọi API khi hết thời gian
            return;
        }
        if(paymentPosStore.dataSmartPos){
            const timer = setInterval(() => {
                paymentPosStore.timeLeft -= 1;
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [paymentPosStore.timeLeft,paymentPosStore.dataSmartPos]);


    const formatTime = (seconds: number) => {   // Định dạng thời gian thành phút:giây
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
    };



    return (
        <>
            <Modal className="modal-form modal-smart-pos-loading" title="Giao dịch đang chờ xử lý" closable={false}
                   open={paymentPosStore.isModalSmartPosLoading} footer={null}>
                <div className={'note-text'}>
                    {paymentPosStore.isCreateSmartPos ? (
                        <>
                            <p>Hệ thống đang xác thực thanh toán.</p>
                            <p>Vui lòng không tắt trình duyệt này hoặc reset lại trang!</p>
                        </>
                    ) : (
                        <>
                            <p>Kết nối thiết bị Smart POS thành công, đang chờ khách hàng thanh toán. Vui lòng không tắt
                                trình duyệt này hoặc reset lại trang!</p>
                        </>
                    )}

                </div>
                <OrbitProgress dense color="#0E72ED" size="medium" text="" textColor=""/>

                {paymentPosStore.isCreateSmartPos === false && (
                    <>
                        <p>Hủy giao dịch sau: <strong>{formatTime(paymentPosStore.timeLeft)}</strong></p>
                        {paymentPosStore.isShowButtonConfirm ? (
                            <div className={`button-cancel list-button`} >
                                <button onClick={() => {
                                    paymentPosStore.fetchCancelPaymentPos((route) => navigate(route))
                                }}>
                                    {paymentPosStore.isSave ? 'Đang xử lý...' : 'Hủy bỏ'}
                                </button>
                                <button className={'btn-confirm'} onClick={() => {
                                    paymentPosStore.fetchMposManualCallback((route) => navigate(route))
                                }}>
                                    {paymentPosStore.isSaveConfirm ? 'Đang xử lý...' : 'Xác nhận'}

                                </button>
                            </div>
                        ) : (
                            <div className={`button-cancel`} >
                                <button onClick={() => {
                                    paymentPosStore.fetchCancelPaymentPos((route) => navigate(route))
                                }}>
                                    {paymentPosStore.isSave ? 'Đang xử lý...' : 'Hủy bỏ'}
                                </button>

                            </div>
                        )}

                    </>
                )}
            </Modal>
        </>
    )
}
export default observer(ModalSmartPosLoading)